import { gql } from '@apollo/client';

const ADD_CUSTOMER_PACKAGE = gql(/* GraphQL */ `
  mutation addCustomerPackage($appId: AppId, $offerId: ID!, $deviceId: ID!) {
    addCustomerPackage(appId: $appId, offerId: $offerId, deviceId: $deviceId) {
      __typename
      ... on InvalidCustomerAccountForPurchase {
        reason
      }
      ... on AddCustomerPackageRejectedResponse {
        customerMessage
        internalMessage
      }
    }
  }
`);
export default ADD_CUSTOMER_PACKAGE;
